"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartQuantityChanged = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function quantityChangedLabel(changedProduct, quantityDifference) {
    return `${changedProduct.trackingName}_${Math.abs(quantityDifference)}`;
}
const trackCartQuantityChanged = (changedProduct, quantityDifference) => {
    if (!changedProduct) {
        return;
    }
    const action = quantityDifference > 0 ? enums_1.CartEventType.IncreaseAmount : enums_1.CartEventType.DecreaseAmount;
    const eventName = quantityDifference > 0 ? enums_1.GA4EventName.IncreaseCount : enums_1.GA4EventName.DecreaseCount;
    const label = quantityChangedLabel(changedProduct, quantityDifference);
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: action,
        eventLabel: label,
        eventData: {
            eventName,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            product_count_changed: quantityDifference,
            product_title: changedProduct.title,
        },
    });
};
exports.trackCartQuantityChanged = trackCartQuantityChanged;
//# sourceMappingURL=trackCartQuantityChanged.js.map